import styled from 'styled-components';
import theme from 'src/styles/theme';
import { device } from 'src/styles/global';
import { Button } from '@dsny/dsny-component-library';

export const ModalHeadingWrapper = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${theme.colors.neutralW20};
  margin-bottom: 8px;
`;

export const ModalDescWrapper = styled.div`
  font-size: 14px;
  color: ${theme.colors.neutralW20};
  margin-bottom: 32px;

  @media ${device.mobile} {
    margin-bottom: 24px;
  }
`;

export const ModalBodyWrapper = styled.div`
  margin-bottom: 32px;

  @media ${device.mobile} {
    margin-bottom: 24px;
  }
`;

export const FlexButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
`;

export const ExtendButton = styled(Button)`
  min-width: 130px;
  height: 36px;
`;

export const SpinningStyleWrapper = styled.div`
  padding-top: 8px;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const DesktopWrapper = styled.div`
  @media ${device.mobile} {
    display: none;
  }
`;

export const MobileWrapper = styled.div`
  @media ${device.tablet} {
    display: none;
  }

  @media ${device.ipad} {
    display: none;
  }

  @media ${device.laptop} {
    display: none;
  }

  @media ${device.desktop} {
    display: none;
  }
`;

export const ErrorWrapper = styled.div`
  margin-bottom: 32px;

  @media ${device.mobile} {
    margin-bottom: 24px;
  }
`;
